import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-homme-cle',
  standalone: true,
  imports: [PageLayoutComponent, CommonModule, RouterModule],
  templateUrl: './assurance-homme-cle.component.html',
  styleUrls: ['./assurance-homme-cle.component.scss']
})
export class AssuranceHommeCleComponent {
  title = 'Assurance Homme-Clé';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/hommecle.jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'Homme Clé', link: undefined }
  ];

  prevPage = { 
    title: 'Perte d\'Exploitation',
    link: '/assurance-perte-exploitation'
  };

  nextPage = { 
    title: 'Crédit Professionnel',
    link: '/assurance-credit-professionnel'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
